// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__OQh1Y","header":"ClearentDisclaimer_header__1Jtx5","inner":"ClearentDisclaimer_inner__3iY6T"};